import React, { FunctionComponent } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';
import { DataLayerEcomErrors } from 'src/types/data-layer-event-object';

export const PageNotAvailable: FunctionComponent = () => (
  <CommonError
    title={i18n.page.error.notAvailable.title}
    subtitles={[i18n.page.error.notAvailable.mainSubtitle, i18n.page.error.notAvailable.subtitle]}
    image={monkeyImageProps}
    dataLayerErrorMessage={DataLayerEcomErrors.NOT_AVAILABLE_PARTNER_ERROR}
  />
);
